import React, { useState, useRef, useLayoutEffect } from 'react';
import AvatarEditor from 'react-avatar-editor';

import './ImageCropModal.css';

const ImageCropModal = ({ id, isOpen, onClose, onSave, isMobile=false }) => {
  const [image, setImage] = useState(null);
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState(null);
  const editorRef = useRef(null);

  useLayoutEffect(() => {
    if (!isOpen) return;
    const navbar = document.getElementById('NavBar') || document.getElementById('navBarMobile');
    const charsheet = document.getElementById('charsheet-full')
      || document.querySelector('[id^="charsheet-"]');

    const navbarRect = navbar ? navbar.getBoundingClientRect() : null;
    const charsheetRect = charsheet ? charsheet.getBoundingClientRect() : null;

    const top = (navbarRect ? navbarRect.bottom : 0) + 30;
    const left = charsheetRect
      ? charsheetRect.left + charsheetRect.width / 2
      : window.innerWidth / 2;

    setPosition({ top, left });
  }, [isOpen]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };

  const handleSave = () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImageScaledToCanvas();
      canvas.toBlob((blob) => {
        const croppedImage = new File([blob], 'cropped-image.jpg', { type: 'image/jpeg' });
        onSave(croppedImage);
        onClose();
        setImage(null);
      }, 'image/jpeg');
    }
  };

  if (!isOpen) return null;

  return (
    <div id={id} className="image-crop-modal-overlay">
      <div
        className={ isMobile ? "image-crop-modal image-crop-modal-mobile" : "image-crop-modal" }
        style={position ? { top: `${position.top}px`, left: `${position.left}px` } : { visibility: 'hidden' }}
      >
        <h1>Select & Crop Image</h1>
        <div className="image-crop-modal-body">
          {image ? (
            <AvatarEditor
              ref={editorRef}
              image={image}
              width={480}
              height={360}
              border={50}
              scale={scale}
              rotate={0}
              className="image-crop-modal-editor"
            />
          ) : (
            <div className="image-crop-modal-file-wrapper">
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="image-crop-modal-file"
              />
            </div>
          )}
          {image && (
            <div className="image-crop-modal-zoom">
              <label className="image-crop-modal-zoom-label">Zoom</label>
              <input
                type="range"
                min="1"
                max="2"
                step="0.01"
                value={scale}
                onChange={(e) => setScale(parseFloat(e.target.value))}
                className="image-crop-modal-zoom-input"
              />
            </div>
          )}
        </div>
        <div className="image-crop-modal-buttons">
          <button
            onClick={onClose}
            className="image-crop-modal-button"
          >
            Cancel
          </button>
          {image && (
            <button
              onClick={handleSave}
              className="image-crop-modal-button image-crop-modal-button-primary"
            >
              Save
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageCropModal;
